import * as $ from 'jquery'

$('#add-bloc_btn2').click(function () {
    const type = $('#type_bloc').val()
    const article = $('#article_id')
    if (type !== '') {
        $.ajax({
            method: 'GET',
            url: '/' + article.data('prefix-route') + '/article/template/bloc/' + article.val() + '/' + type,
            success: function (data) {
                $('#blocs').append(data)
                $('#blocs-container').show()
                removeBloc()
                addQuestion()
            }
        })
    }
})

removeBloc()
addQuestion()

if ($('#blocs').length > 0) {
    // let element = document.querySelector('.sortable')
    /* new Sortable(element, {
        handle: '.move_cursur',
        animation: 150
    }) */
}

function addQuestion () {
    $('.add-question-btn').click(function () {
        const blocId = $(this).data('bloc_id')
        const index = parseInt($('#nb-question-' + blocId).val()) + 1
        const article = $('#article_id')
        $('#nb-question-' + blocId).val(index)
        $.ajax({
            method: 'GET',
            url: '/' + article.data('prefix-route') + '/article/template/faq/' + blocId + '/' + index,
            success: function (data) {
                $('#question-bloc-' + blocId).append(data)
            }
        })
    })
}

function removeBloc () {
    $('.remove-bloc').click(function () {
        const blocId = $(this).attr('id')
        // eslint-disable-next-line no-undef
        if (confirm('Êtes-vous sûre de vouloir supprimer ce bloc ?') === true) {
            $('#bloc_' + blocId).remove()
        }
    })
}
